exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pr[data-v-7e4476a4] {\n  padding-right: 20px !important;\n}\n.pl[data-v-7e4476a4] {\n  padding-left: 20px !important;\n}\n", ""]);

// exports
